const AdUnitTypeChoices = [
  { id: 'anchored', name: 'Anchored' },
  { id: 'incremental', name: 'Incremental' },
  { id: 'keystone', name: 'Keystone' },
  { id: 'interscroller', name: 'Interscroller' },
  { id: 'native', name: 'Native' },
  { id: 'oop', name: 'OOP' },
  { id: 'skyscraper', name: 'Skyscraper' },
  { id: 'sponsored', name: 'Sponsored' },
  { id: 'standard', name: 'Standard' }
];

export default AdUnitTypeChoices;



// WEBPACK FOOTER //
// ./src/views/Components/Placements/StaticData/AdUnitTypeChoices.tsx